import React from 'react';
export const RecordFill = props => (
  <svg viewBox="0 0 20 20" width="16px" height="16px" {...props} className={`btfont ${props.className ? props.className : ''}`}><path d="M8 13A5 5 0 1 0 8 3a5 5 0 0 0 0 10z" fillRule="evenodd" /></svg>
);
